(function ($) {
    'use strict';

    /**
     *  richtextEditorConfig {
     *      plugins: {
     *          keycheck: {
     *              keys: [
     *                  {
     *                      altKey: bool,
     *                      ctrlKey: bool,
     *                      shiftKey: bool,
     *                      which: keycode,
     *                      callback: function
     *                  }
     *              ]
     *          }
     *      }
     *  }
     */

    var defaultOptions = {};

    function keypressHandler(evt) {
        var opts = evt.data || {};

        (opts.keys || []).map(function (key) {
            if ((evt.altKey == !!key.altKey) && (evt.ctrlKey == !!key.ctrlKey) && (evt.shiftKey == !!key.shiftKey) && (evt.which == key.which)) {
                evt.preventDefault();
                key.callback();
            }
        });
    }

    $.extend(true, $.trumbowyg, {
        langs: {
            en: {
                keycheck: 'keycheck'
            }
        },

        plugins: {
            keycheck: {
                init: function (trumbowyg) {
                    trumbowyg.o.plugins.keycheck = $.extend(true, {},
                        defaultOptions,
                        trumbowyg.o.plugins.keycheck || {}
                    );

                    // unfortunatly we need to wait a moment or two to give the control time to
                    // initialize before we try to hook up our keyboard listener
                    setTimeout(function () {
                        trumbowyg.$ed.on('keypress.keycheck', null, trumbowyg.o.plugins.keycheck, keypressHandler);
                    }, 500);
                },
                destroy: function (trumbowyg) {
                    trumbowyg.$ed.off('keypress.keycheck');
                }
            }
        }
    })
})(jQuery);